
import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import Programs from '../pages/programs/page';
import About from '../pages/about/page';
import SessionTimes from '../pages/session-times/page';
import Register from '../pages/register/page';
import Blog from '../pages/blog/page';
import Contact from '../pages/contact/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/programs',
    element: <Programs />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/session-times',
    element: <SessionTimes />,
  },
  {
    path: '/sessions',
    element: <SessionTimes />,
  },
  {
    path: '/register',
    element: <Register />,
  },
  {
    path: '/blog',
    element: <Blog />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
